import Box from "@mui/material/Box";
import {
  Autocomplete,
  CircularProgress,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  InputAdornment,
} from "@mui/material";
import AppButton from "../../common/AppButton";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { Formik, Form, Field } from "formik";
import {
  AddBatch,
  editBatch,
  getBatchData,
  validateBatch,
} from "../../../features/batch/batchSlice";
import { addBatchInitialValues } from "../../forms/initialValues";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { useCallback, useEffect, useRef, useState } from "react";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { getSupplierData } from "../../../features/supplier/supplierSlice";
import {
  getAllMedicineData,
  getAllNonMedicineData,
} from "../../../features/medicine/medicineSlice";
import AppModal from "../../common/AppModal";
import AddMedicineModal from "../medicine/medicine-add-model";
import AppErrorMessage from "../../common/AppErrorMessage";
import { Dropdown } from "./dropdown";
import { ProductDropDown } from "./productDropDown";
import { getNonMedicalData } from "../../../features/nonMedical/nonMedicalSlice";
import AddNonMedicalModal from "../nonmedical/nonmedical-add-model";
import AddSupplierModal from "../supplier/supplier-add-model";
import SupplierBatchModal from "./supplier_batch_modal";
import AddNewShelfModal from "../../shelf-number-management/addNewShelfModal";
import { PharmacySuperCategory } from "../../../utils/constants";
import { useSelector } from "react-redux";
import BarcodeReader from "react-barcode-reader";
import { get_shelf_system } from "../../../features/shelfNumberSystem/shelfNumberService";
import axios from "../../../utils/axiosConfig";
import InputIcon from "../../../assets/icon/inputIcon.svg";
import { set } from "date-fns";

const initialErrors = {
  apiError: false,
  // medicineNameError: "",
  supplierError: "",
  dateError: "",
  batchNoError: "",
  quantityError: "",
  sellPriceError: "",
  costPriceError: "",
  costPriceLessError: "",
  extraDiscountBonusError: "",
  boxQuantityError: "",
  unitsPerBoxError: "",
};
// interface IProps {
//   handleClose: () => void;
//   setOpenSnackbar: () => void;
//   batch?: any;
//   isEdit: boolean;
// }

const AddBatchModal = ({
  handleClose,
  setOpenSnackbar,
  batch,
  isEdit,
  setExpireMedCount,
  setNearExpireMedCount,
  selectedMedicineId,
  getMedicine,
}) => {
  const dispatch = useAppDispatch();
  const { staff_id } = useSelector((state) => state?.staff);
  const staff_data = localStorage?.getItem("staff_data");
  const StaffData = staff_data ? JSON?.parse(staff_data) : null;
  const [shelfData, setShelfData] = useState([]);
  const [debouncedBatchNo, setDebouncedBatchNo] = useState("");
  const [medicineId, setMedicineId] = useState("");
  const [addSupplierId, setAddSupplierId] = useState("");
  const [addShelfId, setAddShelfId] = useState("");
  const [activeField, setActiveField] = useState(null);
  
  const Id = staff_id || StaffData?.id;
  const [batchStates, setBatchStates] = useState({
    supplierId: batch?.supplier?.id || null,
    batchName: batch?.batch_no || "",
    quantity: batch?.quantity || "",
    supplier: batch?.supplier?.supplier_company_name || "",
    sellPrice: batch?.sell_price || "",
    sell_price_per_box: batch?.sell_price_per_box || "",
    invoiceNumber: batch?.stock_inv_no || "",
    filePath: batch?.stock_inv_file || "",
    costPrice: batch?.cost_price || "",
    cost_price_per_box: batch?.cost_price_per_box || "",
    tax_amount: batch?.tax_amount || "",
    stock_purchase_cost: batch?.stock_purchase_cost || "",
    batch_discount: batch?.batch_discount || "",
    stockOutReminder: batch?.stock_out_reminder?.stock_out_reminder
      ? `${batch.stock_out_reminder.stock_out_reminder}%`
      : "30%",
    expiryReminder: batch?.expiry_reminder
      ? `${batch?.expiry_reminder} Months Before`
      : "6 Months Before",
    prodDate: batch?.production_date || null,
    stockDate: batch?.batch_purchase_date || null,
    expDate: batch?.expiry_date || null,
    openProductionDatePicker: false,
    openExpiryDatePicker: false,
    openStockPicker: false,
    supplierData: [],
    batchId: null,
    openModal: false,
    openSupplierModal: false,
    openShelfModal: false,
    openSupplierBatchModal: false,
    medicineData: null,
    nonmedicineData: null,
    productionSelectedDate: null,
    stockSelectDate: null,
    expirySelectedDate: null,
    boxQuantity: batch?.total_box || null,
    unitsPerBox: batch.unit_per_box || null,
    isOpen: false,
    loading: false,
    medicalType: batch?.super_category ? "nonmedical" : "medical",
    medicalTypeValue: batch?.super_category
      ? PharmacySuperCategory.NONMEDICAL
      : PharmacySuperCategory.MEDICAL,
    openProductModal: false,
    selectedBatch: null,
    shelfsData: [],
    selectedShelf: batch?.shelf,
  });


  const allSupplier = batchStates?.supplierData?.payload?.supplier;

  const { supplierId, supplier, openSupplierBatchModal } = batchStates;

  useEffect(() => {
    if (supplierId && supplier && !isEdit) {
      setBatchStates((prev) => ({
        ...prev,
        openSupplierBatchModal: true,
      }));
    }
  }, [supplierId, supplier, isEdit]);

  const [allMedicineId, setAllMedicineId] = useState(
    batch ? batch?.pharmacy_medicine?.id : null
  );
  const [allMedicalProductId, setAllMedicalProductId] = useState(
    batch ? batch?.pharmacy_medicine?.id : null
  );
  const [medicineName, setMedicineName] = useState(
    batch
      ? `${batch?.pharmacy_medicine?.name} ${batch?.pharmacy_medicine?.dose}`
      : ""
  );

  const [ProductName, setProductName] = useState(
    batch
      ? `${batch?.pharmacy_medicine?.name} ${batch?.pharmacy_medicine?.dose}`
      : ""
  );
  const [selectedMed, setSelectedMed] = useState("");
  const [medicinError, setMedicinError] = useState("");
  const [extraDisError, setExtraDisError] = useState("");
  const [medBC_id, setMedBC_id] = useState("");
  const [medCodeBoolen, setMedCodeBoolen] = useState(false);
  const [med_value, setMed_Value] = useState("");
  const [errors, setErrors] = useState(initialErrors);

  const [medBarcode, setMedBarcode] = useState(
    batch?.pharmacy_medicine?.barcode ?? ""
  );
  const [medNonMedTrue, setMedNonMedTrue] = useState(false);
  const [showMoreFields, setShowMoreFields] = useState(false);
  // Add new state for supplier-medicine filtering
  const [filteredBySupplier, setFilteredBySupplier] = useState(false);
  const [supplierMedicines, setSupplierMedicines] = useState([]);

  useEffect(() => {
    if (batchStates?.quantity?.length > 0) {
      if (batchStates.quantity < batch?.quantity_sold) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          quantityError: "Stock In is less than Stock Out", // Clear the error message
        }));
      }
    }
  }, [batchStates?.quantity, batch?.quantity_sold]);

  useEffect(() => {
    const unitsPerBox = parseFloat(batchStates?.unitsPerBox);
    const sellPrice = parseFloat(batchStates?.sellPrice);
    if (!isNaN(unitsPerBox) && !isNaN(sellPrice)) {
      setBatchStates((prevState) => ({
        ...prevState,
        sell_price_per_box: unitsPerBox * sellPrice,
      }));
    } else {
      setBatchStates((prevState) => ({
        ...prevState,
        sell_price_per_box: "",
      }));
    }
  }, [batchStates?.unitsPerBox, batchStates?.sellPrice]);

  useEffect(() => {
    const unitsPerBox = parseFloat(batchStates?.unitsPerBox);
    const costPrice = parseFloat(batchStates?.costPrice);
    const cost_price_per_box = parseFloat(batchStates?.cost_price_per_box);
    // ✅ Skip calculations if the user is actively clearing the input
    if (
      activeField !== "cost_price_per_box" &&
      batchStates?.costPrice !== "" &&
      !isNaN(unitsPerBox) &&
      !isNaN(costPrice)
    ) {
      setBatchStates((prevState) => ({
        ...prevState,
        cost_price_per_box: costPrice * unitsPerBox,
      }));
    } else if (
      activeField !== "cost_price" &&
      batchStates?.cost_price_per_box !== "" &&
      !isNaN(unitsPerBox) &&
      !isNaN(cost_price_per_box)
    ) {
      const calculatedCostPrice = cost_price_per_box / unitsPerBox;

      // Ensure it's a valid number
      if (!isNaN(calculatedCostPrice) && calculatedCostPrice !== costPrice) {
        setBatchStates((prev) => ({
          ...prev,
          costPrice: calculatedCostPrice,
        }));
      }
    } else if (
      activeField === "cost_price_per_box" &&
      batchStates?.cost_price_per_box === "" 
    ) {
      // If the user clears cost_price_per_box, clear costPrice too
      setBatchStates((prev) => ({
        ...prev,
        cost_price_per_box: "",
        costPrice: "",
      }));
    }else if(
      activeField === "cost_price" &&
      batchStates?.costPrice === ""
    ){
      // If the user clears costPrice, clear cost_price_per_box too
      setBatchStates((prev) => ({
        ...prev,
        costPrice: "",
        cost_price_per_box: "",
      }));
    }
  }, [
    batchStates?.unitsPerBox,
    batchStates?.cost_price_per_box,
    batchStates?.costPrice,
    activeField,
  ]);

  const inputRef = useRef();

  const handleBarChange = (e) => {
    let value = e?.target?.value.trim();
    if (value.length <= 13) {
      setMedBarcode(value);
    }
  };

  const fetchShelves = async () => {
    try {
      const res = await get_shelf_system({
        page: 1,
        limit: 1000,
        search: "",
        pharmacy_id: pharmacyId,
      });
      setShelfData(res?.data?.shelf || []);
      setBatchStates((prevState) => ({
        ...prevState,
        shelfsData: res,
      }));
    } catch (error) {
      console.error("Error fetching shelf data:", error);
    }
  };

  const getSupplierMedicines = async (pharmacy_id, supplier_id) => {
    try {
      setBatchStates((prevState) => ({
        ...prevState,
        loading: true,
      }));
      const url = `/api/pharmacy/supplier/get_supplier_med?pharmacy_id=${encodeURIComponent(
        pharmacy_id
      )}&supplier_id=${encodeURIComponent(supplier_id)}`;
      const { data } = await axios.get(url);
      return data;
    } catch (error) {
      console.error("Error fetching supplier medicines:", error);
      throw error;
    } finally {
      setBatchStates((prevState) => ({
        ...prevState,
        loading: false,
      }));
    }
  };

  useEffect(() => {
    let barcode = "";
    let timeout;

    const handleBarcodeKeydown = (event) => {
      if (event.key === "Enter" && barcode.length > 0 && barcode.length <= 13) {
        handleScan(barcode); // Call scan function when 13 digits are complete
        barcode = ""; // Reset barcode buffer
        return;
      }

      if (!isNaN(event.key)) {
        barcode += event.key; // Append digits to barcode
        clearTimeout(timeout);
        timeout = setTimeout(() => (barcode = ""), 500); // Reset if no input in 500ms
      }
    };

    window.addEventListener("keydown", handleBarcodeKeydown);
    return () => window.removeEventListener("keydown", handleBarcodeKeydown);
  }, [batchStates?.medicalType]); // Reset when tab changes

  const handleScan = (data) => {
    if (data && medBarcode === "") {
      setMedBarcode((prev) => (prev !== data ? data : prev));
    }
  };

  const handleError = (err) => {
    console.error(err);
  };

  const AllProducts = useAppSelector(
    (state) => state?.nonMedical?.medicineDetails
  );

  const productOptions = AllProducts?.map((product) => ({
    name: product?.name,
    id: product?.id,
  }));
  const pharmacyNonMedicalId = localStorage?.getItem("pharmacyId");

  const getMedical = useCallback(() => {
    const data = dispatch(getNonMedicalData(pharmacyNonMedicalId));
  }, [dispatch, pharmacyNonMedicalId]);
  useEffect(() => {
    getMedical();
  }, [getMedical]);
  const handleChange = (event) => {
    setMed_Value(event?.target?.value);
    if (medCodeBoolen) {
      setMedBC_id("");
      setMedBarcode("");
    }
    setBatchStates((prevState) => ({
      ...prevState,
      isOpen: true,
    }));
    // setErrors((prevErrors) => ({
    //   ...prevErrors,
    //   medicineNameError: "", // Clear the error message if valid
    // }));
    setMedicinError("");
  };

  const handleChangeEdit = (event) => {
    setMedicineName(event?.target?.value);
    setBatchStates((prevState) => ({
      ...prevState,
      isOpen: true,
    }));
  };

  const handleChangeProductEdit = (event) => {
    setProductName(event.target.value);
    setBatchStates((prevState) => ({
      ...prevState,
      isOpen: true,
    }));
  };

  const handleAddProductionDateChange = (date) => {
    setBatchStates((prevState) => ({
      ...prevState,
      productionSelectedDate: date,
    }));
  };

  const handleAddStockSelectDateChange = (date) => {
    setBatchStates((prevState) => ({
      ...prevState,
      stockSelectDate: date,
    }));
  };

  const handleAddExpiryDateChange = (date) => {
    setBatchStates((prevState) => ({
      ...prevState,
      expirySelectedDate: date,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      dateError: "", // Clear the error message if valid
    }));
  };

  const handleOpenProductModal = () => {
    setBatchStates((prevState) => ({
      ...prevState,
      openProductModal: true,
      isOpen: false,
    }));
  };
  const handleCloseProductModal = () => {
    setBatchStates((prevState) => ({
      ...prevState,
      openProductModal: false,
    }));
  };

  const handleOpenModal = () => {
    setBatchStates((prevState) => ({
      ...prevState,
      openModal: true,
      isOpen: false,
    }));
  };
  const handleCloseModal = () => {
    setBatchStates((prevState) => ({
      ...prevState,
      openModal: false,
    }));
  };

  const handleOpenSupplierModal = () => {
    setBatchStates((prevState) => ({
      ...prevState,
      openSupplierModal: true,
      isOpen: false,
    }));
  };
  const handleCloseSupplierModal = () => {
    setBatchStates((prevState) => ({
      ...prevState,
      openSupplierModal: false,
    }));
  };
  const handleCloseSupplierBatchModal = () => {
    setBatchStates((prevState) => ({
      ...prevState,
      openSupplierBatchModal: false,
    }));
  };

  const handleOpenShelfModal = () => {
    setBatchStates((prevState) => ({
      ...prevState,
      openShelfModal: true,
      isOpen: false,
    }));
  };
  const handleCloseShelfModal = () => {
    setBatchStates((prevState) => ({
      ...prevState,
      openShelfModal: false,
    }));
  };

  const pharmacyId = localStorage?.getItem("pharmacyId");

  const fatchBatchData = async () => {
    try {
      const res = await dispatch(getBatchData({ pharmacy_id: pharmacyId }));
      setExpireMedCount(res?.payload?.counts?.expireCount || 0);
      setNearExpireMedCount(res?.payload?.counts?.nearExpireCount || 0);
    } catch (error) {
      console.error("Error fetching batch data:", error);
    }
  };
  // Label helper
  const getFieldLabel = (name) => {
    switch (name) {
      case "boxQuantity":
        return "Total Boxes";
      case "unitsPerBox":
        return "Units per Box";
      case "quantity":
        return "Total Stock";
      default:
        return name;
    }
  };
  const handleStockCalculationChange = (e) => {
    const { name, value } = e.target;
    const numericValue = parseFloat(value);
    const isCleared = value === "";

    // 💡 Clear input case (empty, NaN, or 0)
    if (isCleared || isNaN(numericValue) || numericValue === 0) {
      setBatchStates((prev) => {
        const newState = { ...prev, [name]: "" };
        if (
          (name === "unitsPerBox" &&
            (isCleared || isNaN(numericValue) || numericValue === 0)) ||
          (name === "boxQuantity" &&
            (isCleared || isNaN(numericValue) || numericValue === 0))
        ) {
          newState.quantity = 0;
        }
        return newState;
      });

      setErrors((prev) => ({
        ...prev,
        [`${name}Error`]: "",
      }));

      return;
    }

    // 🔐 Negative number validation
    if (numericValue < 0) {
      setErrors((prev) => ({
        ...prev,
        [`${name}Error`]: `${getFieldLabel(name)} cannot be negative`,
      }));
      return;
    }

    // 🔐 Whole number validation
    if (!Number.isInteger(numericValue)) {
      setErrors((prev) => ({
        ...prev,
        [`${name}Error`]: `${getFieldLabel(name)} must be a whole number`,
      }));
      return;
    }

    setBatchStates((prev) => {
      const newState = { ...prev, [name]: numericValue };
      const newErrors = { ...errors };

      const boxQty = name === "boxQuantity" ? numericValue : prev.boxQuantity;
      const units = name === "unitsPerBox" ? numericValue : prev.unitsPerBox;

      // ✅ Recalculate quantity
      if (boxQty > 0 && units > 0) {
        newState.quantity = boxQty * units;
        newErrors.quantityError = "";
      }
      // ✅ Quantity manually entered
      if (name === "quantity") {
        newState.quantity = numericValue;
        if (numericValue < (batch?.quantity_sold || 0)) {
          newErrors.quantityError = `Stock In (${numericValue}) is less than Stock Out (${
            batch?.quantity_sold || 0
          })`;
        } else {
          newErrors.quantityError = "";
        }
        // Backfill boxQuantity
        if (!prev.boxQuantity && units > 0) {
          const calculatedBoxes = numericValue / units;
          if (Number.isInteger(calculatedBoxes)) {
            newState.boxQuantity = calculatedBoxes;
            newErrors.boxQuantityError = "";
          } else {
            newErrors.boxQuantityError =
              "Cannot calculate valid number of boxes (not a whole number)";
          }
        }
        // Backfill unitsPerBox
        if (!prev.unitsPerBox && boxQty > 0) {
          const calculatedUnits = numericValue / boxQty;
          if (Number.isInteger(calculatedUnits)) {
            newState.unitsPerBox = calculatedUnits;
            newErrors.unitsPerBoxError = "";
          } else {
            newErrors.unitsPerBoxError =
              "Cannot calculate valid units per box (not a whole number)";
          }
        }
      }
      newErrors[`${name}Error`] = "";
      setErrors(newErrors);
      return newState;
    });
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
   
    setActiveField(name); // Track which input is being edited
    setBatchStates((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    switch (name) {
      case "batch_no":
        setBatchStates((prevState) => ({
          ...prevState,
          batchName: value,
        }));

        // Trigger debounced change
        // setDebouncedBatchNo(value);

        // Clear error (if applicable)
        setErrors((prevErrors) => ({
          ...prevErrors,
          batchNoError: "",
        }));
        break;
      case "quantity":
        setBatchStates((prevState) => ({
          ...prevState,
          quantity: value,
        }));

        // Check for negative numbers
        if (parseFloat(value) < 0) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            quantityError: "Total Stock cannot be negative",
          }));
        } else if (value < batch?.quantity_sold) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            quantityError: "Stock In is less than Stock Out",
          }));
        } else {
          setErrors((prevErrors) => ({
            ...prevErrors,
            quantityError: "",
          }));
        }
        break;
      case "sell_price":
        setBatchStates((prevState) => ({
          ...prevState,
          sellPrice: value,
        }));

        // Check for negative numbers
        if (parseFloat(value) < 0) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            sellPriceError: "Sell Price cannot be negative",
          }));
        } else if (
          parseFloat(batchStates?.sellPrice) &&
          parseFloat(value) < parseFloat(batchStates?.costPrice)
        ) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            sellPriceError: "Sell Price cannot be less than Cost Price",
          }));
        } else {
          setErrors((prevErrors) => ({
            ...prevErrors,
            sellPriceError: "",
          }));
        }

        break;
      case "cost_price":
        setBatchStates((prevState) => ({
          ...prevState,
          costPrice: value,
        }));

        // Check for negative numbers
        if (parseFloat(value) < 0) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            costPriceError: "Cost Price cannot be negative",
            costPriceLessError: "",
          }));
        } else {
          setErrors((prevErrors) => ({
            ...prevErrors,
            costPriceError: "",
            costPriceLessError: "",
          }));
        }
        break;
      case "tax_amount":
        setBatchStates((prevState) => ({
          ...prevState,
          tax_amount: value,
        }));
        break;

      case "invoice_number":
        setBatchStates((prevState) => ({
          ...prevState,
          invoiceNumber: value,
        }));
        break;
      case "purchase_price":
        setBatchStates((prevState) => ({
          ...prevState,
          stock_purchase_cost: value,
        }));
        break;
      case "batch_discount":
        {
          setBatchStates((prevState) => {
            const updatedState = {
              ...prevState,
              batch_discount: value,
            };

            // Check if batch_discount is greater than stock_purchase_cost
            if (
              parseFloat(value) > parseFloat(updatedState.stock_purchase_cost)
            ) {
              setErrors((prevErrors) => ({
                ...prevErrors,
                extraDiscountBonusError:
                  "Extra Discount/Bonus cannot be greater than Stock Purchase Price",
              }));
            } else {
              setErrors((prevErrors) => ({
                ...prevErrors,
                extraDiscountBonusError: "", // Clear error when value is valid
              }));
            }

            return updatedState;
          });
        }

        break;

      case "cost_price_per_box":
        setBatchStates((prevState) => ({
          ...prevState,
          cost_price_per_box: value,
        }));
        if (parseFloat(value) < 0) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            costPriceError: "Cost Price cannot be negative",
          }));
        } else {
          setErrors((prevErrors) => ({
            ...prevErrors,
            costPriceError: "",
          }));
        }
        break;

      default:
        break;
    }
  };

  const handelMedicalType = (filterType) => {
    setFilteredBySupplier(false);
    const typeValue =
      filterType === "medical"
        ? PharmacySuperCategory.MEDICAL
        : PharmacySuperCategory.NONMEDICAL;
    setMed_Value("");
    setBatchStates((prevState) => ({
      ...prevState,
      medicalType: filterType,
      medicalTypeValue: typeValue,
    }));
  };

  const currentDate = new Date(); // Current date
  const fetchAllMedicine = async () => {
    try {
      const data = await dispatch(getAllMedicineData());
      const data1 = await dispatch(getAllNonMedicineData());
      setBatchStates((prevState) => ({
        ...prevState,
        medicineData: data,
      }));
      setBatchStates((prevState) => ({
        ...prevState,
        nonmedicineData: data1,
      }));
    } catch (error) {
      console.error("Error fetching medicine data:", error);
    }
  };

  useEffect(() => {
    fetchAllMedicine();
    fetchSupplierData();
    fetchShelves();
  }, []);

  const fetchSupplierData = async () => {
    try {
      const data = await dispatch(getSupplierData({ pharmacy_id: pharmacyId })); // Assuming getSupplierData is async
      // Assuming getSupplierData returns the fetched data
      setBatchStates((prevState) => ({
        ...prevState,
        supplierData: data,
      }));
    } catch (error) {
      console.error("Error fetching supplier data:", error);
    }
  };

  const handleProductionDateChange = (date) => {
    setBatchStates((prevState) => ({
      ...prevState,
      prodDate: date,
    }));
  };

  const handleStockDateChange = (date) => {
    setBatchStates((prevState) => ({
      ...prevState,
      stockDate: date,
    }));
  };

  const fileInputRef = (useRef < HTMLInputElement) | (null > null);

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (file) {
      setBatchStates((prevState) => ({
        ...prevState,
        filePath: file.name,
      }));
    }
  };

  const handleRemoveFile = () => {
    setBatchStates((prevState) => ({
      ...prevState,
      filePath: "",
    }));
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Clear the input value
    }
  };

  const handleExpiryDateChange = (date) => {
    setBatchStates((prevState) => ({
      ...prevState,
      expDate: date,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      dateError: "", // Clear the error message if valid
    }));
  };

  const handleSubmit = async (values) => {
    // Prevent submission if already loading
    if (batchStates?.loading) {
      return;
    }
    setBatchStates((prevState) => ({
      ...prevState,
      loading: true,
    })); // start the loader

    if (!isEdit) {
      if (selectedMed?.id || medBC_id) {
        setMedicinError("");
      } else if (med_value && !(selectedMed || medBC_id)) {
        setMedicinError("Invalid Medicine");
      } else {
        setMedicinError("Required *");
      }

      if (batchStates?.medicalTypeValue === PharmacySuperCategory.MEDICAL) {
        if (!batchStates?.supplierId) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            supplierError: "Required *",
          }));
        } else {
          // Clear the supplierError
          setErrors((prevErrors) => ({
            ...prevErrors,
            supplierError: "",
          }));
        }
      }
      // Validate date field
      if (!batchStates?.expirySelectedDate) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          dateError: "Required *", // Set the error message for dateError
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          dateError: "", // Clear the error message if valid
        }));
      }
      // Validate batch number
      if (!batchStates?.batchName) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          batchNoError: "Required *",
        }));
      } else if (/^\s/.test(batchStates?.batchName)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          batchNoError: "Batch number cannot contain spaces",
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          batchNoError: "",
        }));
      }
      // Validate quantity
      if (!batchStates?.quantity) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          quantityError: "Required *", // Set the error message
        }));
      } else if (parseFloat(batchStates?.quantity) < 0) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          quantityError: "Total Stock cannot be negative",
        }));
      } else if (batchStates?.quantity < batch?.quantity_sold) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          quantityError: "Stock In is less than Stock Out", // Clear the error message
        }));
      }
     
      // Validate sell price
      if (!batchStates?.sellPrice) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          sellPriceError: "Required *",
        }));
      } else if (parseFloat(batchStates?.sellPrice) < 0) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          sellPriceError: "Sell price cannot be negative",
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          sellPriceError: "",
        }));
      }
      // Validate cost price
      if (!batchStates?.cost_price_per_box) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          costPriceError: "Required *",
        }));
      } else if (parseFloat(batchStates?.cost_price_per_box) < 0) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          costPriceError: "Cost price cannot be negative",
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          costPriceError: "",
        }));
      }
      // Additional validation for cost price less than sell price
      if (batchStates?.stock_purchase_cost < batchStates?.batch_discount) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          extraDiscountBonusError:
            "Extra Discount/Bonus cannot be greater than Stock Purchase Price",
        }));
      }
      if (batchStates?.stock_purchase_cost >= batchStates?.batch_discount) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          extraDiscountBonusError: "",
        }));
      }
      if (
        batchStates?.sellPrice &&
        batchStates?.costPrice &&
        parseFloat(batchStates?.costPrice) >= 0 &&
        parseFloat(batchStates?.sellPrice) >= 0 &&
        parseFloat(batchStates?.costPrice) > parseFloat(batchStates?.sellPrice)
      ) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          costPriceLessError: "Cost price must be less than sell price",
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          costPriceLessError: "",
        }));
      }
      if (
        (batchStates?.medicalTypeValue === PharmacySuperCategory.MEDICAL &&
          !batchStates?.supplierId) ||
        !batchStates?.expirySelectedDate ||
        (med_value && !(selectedMed || medBC_id)) ||
        !batchStates?.batchName ||
        /^\s/.test(batchStates?.batchName) || // Check for spaces in batch number
        !batchStates?.quantity ||
        !batchStates?.sellPrice ||
        !batchStates?.costPrice ||
        parseFloat(batchStates?.sellPrice) < 0 ||
        parseFloat(batchStates?.costPrice) < 0 ||
        parseFloat(batchStates?.costPrice) > parseFloat(batchStates?.sellPrice)
      ) {
        setBatchStates((prevState) => ({
          ...prevState,
          loading: false,
        })); // Stop the loader if validation fails
        return;
      }
    } else {
      // Validation specific to isEdit
      if (!batchStates?.sellPrice) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          sellPriceError: "Required *",
        }));
      } else if (parseFloat(batchStates?.sellPrice) < 0) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          sellPriceError: "Sell price cannot be negative",
        }));
      } else if (batchStates?.sellPrice < batchStates.costPrice) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          sellPriceError: "Sell price cannot be less than cost price",
        }));

      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          sellPriceError: "",
        }));
      }

      if (!batchStates?.cost_price_per_box) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          costPriceError: "Required *",
        }));
      } else if (parseFloat(batchStates?.cost_price_per_box) < 0) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          costPriceError: "Cost price cannot be negative",
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          costPriceError: "",
        }));
      }

      // Validate batch number
      if (!batchStates?.batchName) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          batchNoError: "Required *",
        }));
      } else if (/^\s/.test(batchStates?.batchName)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          batchNoError: "Batch number cannot contain spaces",
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          batchNoError: "",
        }));
      }
      // if (!batchStates?.stock_purchase_cost) {
      //   setErrors((prevErrors) => ({
      //     ...prevErrors,
      //     batchPurchaseError: "Required *",
      //   }));
      // } else if (/^\s/.test(batchStates?.stock_purchase_cost)) {
      //   setErrors((prevErrors) => ({
      //     ...prevErrors,
      //     batchPurchaseError: "Purchase number cannot contain spaces",
      //   }));
      // } else {
      //   setErrors((prevErrors) => ({
      //     ...prevErrors,
      //     batchPurchaseError: "",
      //   }));
      // }
      // Validate quantity
      if (!batchStates?.quantity) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          quantityError: "Required *", // Set the error message
        }));
      } else if (parseFloat(batchStates?.quantity) < 0) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          quantityError: "Total Stock cannot be negative",
        }));
      } else if (batchStates?.quantity < batch?.quantity_sold) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          quantityError: "Stock In is less than Stock Out", // Clear the error message
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          quantityError: "", // Clear the error message
        }));
      }

      if (
        batchStates?.sellPrice &&
        batchStates?.costPrice &&
        parseFloat(batchStates?.costPrice) > parseFloat(batchStates?.sellPrice)
      ) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          costPriceLessError: "Cost price must be less than sell price",
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          costPriceLessError: "",
        }));
      }

      if (
        !batchStates?.sellPrice ||
        !batchStates?.costPrice ||
        !batchStates?.batchName ||
        /^\s/.test(batchStates?.batchName) ||
        // !batchStates?.stock_purchase_cost ||
        // /^\s/.test(batchStates?.stock_purchase_cost) ||
        (med_value && !(selectedMed || medBC_id)) ||
        !batchStates?.quantity ||
        parseFloat(batchStates?.sellPrice) < 0 ||
        parseFloat(batchStates?.costPrice) < 0 ||
        parseFloat(batchStates?.costPrice) >
          parseFloat(batchStates?.sellPrice) ||
        errors?.quantityError?.length > 1
      ) {
        setBatchStates((prevState) => ({
          ...prevState,
          loading: false,
        })); // Stop the loader if validation fails
        return;
      }
    }
    const pharmacyId = localStorage?.getItem("pharmacyId");
    const batchs = {
      staff_id: parseInt(Id),
      // updated_by_admin: Id ? false : true,
      // add_by_admin: Id ? false : true,
      ...(isEdit
        ? { updated_by_admin: Id ? false : true }
        : { add_by_admin: Id ? false : true }),
      batch_id: batchStates?.batchId,
      batch_no: batchStates?.batchName,
      quantity: batchStates?.quantity,
      stock_inv_no: batchStates?.invoiceNumber,
      stock_inv_file: batchStates?.filePath,
      sell_price: batchStates?.sellPrice,
      cost_price: batchStates?.costPrice,
      tax_amount: parseInt(batchStates?.tax_amount),
      pharmacy_id: pharmacyId,
      medicine_id: isEdit
        ? allMedicineId || allMedicalProductId || selectedMed?.id || medBC_id
        : selectedMed?.id || medBC_id,
      supplier_id: batchStates?.supplierId,
      production_date: isEdit
        ? batchStates?.prodDate
        : batchStates?.productionSelectedDate,
      batch_purchase_date: isEdit
        ? batchStates?.stockDate
        : batchStates?.stockSelectDate || new Date(),
      expiry_date: isEdit
        ? batchStates?.expDate
        : batchStates?.expirySelectedDate,
      category_type: batchStates?.medicalTypeValue,
      barcode: medBarcode,
      stock_purchase_cost: batchStates?.stock_purchase_cost,
      batch_discount: batchStates?.batch_discount,
      expiry_reminder: parseInt(batchStates?.expiryReminder),
      stock_out_reminder: parseInt(batchStates?.stockOutReminder),
      shelf_id: batchStates?.selectedShelf?.id,
      shelf_name: batchStates?.selectedShelf?.name,
      total_box: parseInt(batchStates?.boxQuantity) || null,
      unit_per_box: parseInt(batchStates?.unitsPerBox) || null,
      sell_price_per_box: parseInt(batchStates?.sell_price_per_box) || null,
      cost_price_per_box: parseInt(batchStates?.cost_price_per_box) || null,
    };

    if (!batchs?.stock_purchase_cost) {
      delete batchs?.stock_purchase_cost;
    }
    // if (!batchs?.stock_purchase_cost) {
    //   delete batchs?.batch_purchase_date;
    // }

    if (!batchs?.batch_discount) {
      delete batchs?.batch_discount;
    }

    !medBarcode && delete batchs.barcode;

    if (isEdit) {
      try {
        const res = await dispatch(editBatch(batchs));
        if (res.payload.success === true) {
          fatchBatchData();
          setOpenSnackbar();
          handleClose();
          setMedBarcode("");
        } else {
          window.alert("Failed to update batch. Please try again.");
        }
      } catch (error) {
        console.error("Error adding Batch: ", error);
      } finally {
        setBatchStates((prevState) => ({
          ...prevState,
          loading: false,
        })); // Stop the loader
      }
    } else {
      try {
        const res = await dispatch(AddBatch(batchs));
        if (res.payload.success === true) {
          fatchBatchData();
          setOpenSnackbar();
          handleClose();
          setMedBarcode("");
          getMedicine();
        } else {
          setErrors((prevErrors) => ({
            ...prevErrors,
            apiError: res?.payload || "Failed to add batch.",
          }));
        }
      } catch (error) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          apiError: true || "An unexpected error occurred.",
        }));
        console.error("Error adding Batch: ", error);
      } finally {
        setBatchStates((prevState) => ({
          ...prevState,
          loading: false,
        })); // Stop the loader
      }
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Prevent default behavior of Enter key
    }
  };

  const handleKeyDownNonNegative = (event) => {
    // Prevent negative sign, 'e' (for scientific notation), and Enter key
    if (event.key === "-" || event.key === "e" || event.key === "Enter") {
      event.preventDefault();
    }
  };

  const handleBlur = () => {
    setActiveField(null);
  };

  useEffect(() => {
    setBatchStates((prevState) => ({
      ...prevState,
      batchId: batch?.id,
    }));

    const select_medicine_id = Array.isArray(batchStates?.medicineData?.payload)
      ? batchStates?.medicineData?.payload?.find(
          (allMedicine) => allMedicine?.name === batch?.pharmacy_medicine?.name
        )
      : undefined;
    setAllMedicineId(select_medicine_id?.id);

    if (batchStates?.supplierData?.length > 0) {
      const select_supplier_id =
        batchStates?.supplierData?.payload?.supplier?.find(
          (supplier) =>
            supplier?.supplier_company_name ===
              batch?.supplier?.supplier_company_name && supplier?.id
        );
      setBatchStates((prevState) => ({
        ...prevState,
        supplierId: select_supplier_id?.id,
      }));
    }
  }, [batchStates?.medicineData, batchStates?.supplierData]);

  const options2 = Array.isArray(batchStates?.medicineData?.payload)
    ? batchStates?.medicineData?.payload?.map((medicine) => ({
        name: medicine?.name.trim(),
        dose: medicine?.dose,
        id: medicine?.id,
        barcode: medicine?.barcode,
      }))
    : [];

  const options2Supplier = Array.isArray(supplierMedicines)
    ? supplierMedicines?.map((medicine) => ({
        name: medicine?.name.trim(),
        dose: medicine?.dose,
        id: medicine?.id,
        barcode: medicine?.barcode,
      }))
    : [];

  const optionsSupplier = options2Supplier
    ? options2Supplier?.sort((a, b) => a?.name?.localeCompare(b?.name))
    : [];

  const options = options2
    ? options2?.sort((a, b) => a?.name?.localeCompare(b?.name))
    : [];
  const options3 = Array.isArray(batchStates?.nonmedicineData?.payload)
    ? batchStates?.nonmedicineData?.payload?.map((medicine) => ({
        name: medicine?.name.trim(),
        dose: medicine?.dose,
        id: medicine?.id,
        barcode: medicine?.barcode,
      }))
    : [];

  const options3Supplier = Array.isArray(supplierMedicines)
    ? supplierMedicines?.map((medicine) => ({
        name: medicine?.name.trim(),
        dose: medicine?.dose,
        id: medicine?.id,
        barcode: medicine?.barcode,
      }))
    : [];

  const options4 = options3
    ? options3?.sort((a, b) => a?.name?.localeCompare(b?.name))
    : [];

  const options4Supplier = options3Supplier
    ? options3Supplier?.sort((a, b) => a?.name?.localeCompare(b?.name))
    : [];

  const optionsProduct = productOptions
    ? productOptions?.sort((a, b) => a?.name?.localeCompare(b?.name))
    : [];

  const filtered_list =
    med_value != null
      ? options?.filter(function (item) {
          return item?.name
            ?.toLowerCase()
            ?.startsWith(med_value?.toLowerCase());
        })
      : options;

  const filtered_list_supplier =
    med_value != null
      ? optionsSupplier?.filter(function (item) {
          return item?.name
            ?.toLowerCase()
            ?.startsWith(med_value?.toLowerCase());
        })
      : optionsSupplier;

  // useEffect(() => {
  //   if (!med_value) return; /

  //   const name1 = med_value.split("(")[0].trim();
  //   const medBC = options?.find((item) => item?.name === name1);

  //   if (medBC?.barcode && medBC?.barcode !== medBarcode) {
  //     setMedBarcode(medBC.barcode);
  //   }
  // }, [med_value, options]);

  const filtered_list_product =
    med_value != null
      ? options4?.filter(function (item) {
          return item?.name
            ?.toLowerCase()
            ?.startsWith(med_value?.toLowerCase());
        })
      : options4;

  const filtered_list_product_supplier =
    med_value != null
      ? options4Supplier?.filter(function (item) {
          return item?.name
            ?.toLowerCase()
            ?.startsWith(med_value?.toLowerCase());
        })
      : options4Supplier;

  useEffect(() => {
    if (!medBarcode) return;
    const optionsList = filteredBySupplier
      ? batchStates?.medicalType === "medical"
        ? optionsSupplier
        : options4Supplier
      : batchStates?.medicalType === "medical"
      ? options
      : options4;

    const medBC = optionsList?.find((item) => item?.barcode === medBarcode);

    setMedCodeBoolen(!!medBC);
    setMed_Value(
      medBC
        ? `${medBC?.name} ${medBC?.dose === " " ? "" : `(${medBC?.dose})`} `
        : ""
    );
    setMedBC_id(medBC ? medBC?.id : "");
    setMedicinError("");
  }, [medBarcode, batchStates?.medicalType]);

  // medical and non medical logic here start

  useEffect(() => {
    const medId = medicineId || selectedMedicineId;
    if (!medId) return;

    const optionsList =
      batchStates?.medicalType === "medical"
        ? batchStates?.medicineData?.payload
        : batchStates?.nonmedicineData?.payload;

    // 🛡️ Wait until optionsList is available
    if (!Array.isArray(optionsList) || optionsList.length === 0) return;

    const medBC = optionsList.find(
      (item) => String(item?.id) === String(medId)
    );

    if (medBC) {
      setMedCodeBoolen(true);
      setMed_Value(
        `${medBC?.name} ${medBC?.dose?.trim() ? `(${medBC?.dose})` : ""}`
      );
      setMedBC_id(medBC?.id);
      setMedicinError("");
    } else {
      setMedCodeBoolen(false);
      setMed_Value("");
      setMedBC_id("");
    }
  }, [
    medicineId,
    selectedMedicineId,
    batchStates?.medicalType,
    batchStates?.medicineData?.payload,
    batchStates?.nonmedicineData?.payload,
  ]);

  useEffect(() => {
    if (!addSupplierId) return;

    const suppliers = batchStates?.supplierData?.payload?.supplier;

    if (!Array.isArray(suppliers) || suppliers.length === 0) return;

    const newSupplier = suppliers.find(
      (supplier) => String(supplier?.id) === String(addSupplierId)
    );

    if (newSupplier) {
      setBatchStates((prev) => ({
        ...prev,
        supplier: newSupplier.supplier_company_name,
        supplierId: newSupplier.id,
      }));

      setErrors((prev) => ({
        ...prev,
        supplierError: "",
      }));
    }
  }, [addSupplierId, batchStates?.supplierData?.payload?.supplier]);

  useEffect(() => {
    if (!addShelfId) return;

    const shelf = batchStates?.shelfsData?.data?.shelf;

    if (!Array.isArray(shelf) || shelf.length === 0) return;

    const newShelf = shelf.find(
      (shelf) => String(shelf?.id) === String(addShelfId)
    );

    if (newShelf) {
      setBatchStates((prev) => ({
        ...prev,
        selectedShelf: newShelf,
      }));

      setErrors((prev) => ({
        ...prev,
        supplierError: "",
      }));
    }
  }, [addShelfId, batchStates?.shelfsData?.data?.shelf]);

  const filtered_list_edit =
    medicineName != null
      ? options?.filter(function (item) {
          return item?.name
            ?.toLowerCase()
            ?.startsWith(medicineName?.toLowerCase());
        })
      : options;
  const filtered_list_edit_supplier =
    medicineName != null
      ? optionsSupplier?.filter(function (item) {
          return item?.name
            ?.toLowerCase()
            ?.startsWith(medicineName?.toLowerCase());
        })
      : optionsSupplier;

  const filtered_listProduct_edit =
    ProductName != null
      ? options4?.filter(function (item) {
          return item?.name
            ?.toLowerCase()
            ?.startsWith(ProductName?.toLowerCase());
        })
      : options4;

  const filtered_listProduct_edit_supplier =
    ProductName != null
      ? options4Supplier?.filter(function (item) {
          return item?.name
            ?.toLowerCase()
            ?.startsWith(ProductName?.toLowerCase());
        })
      : options4Supplier;

  // Medical and non medical logic here start
  useEffect(() => {
    if (!medicineId) return;

    const optionsList =
      batchStates?.medicalType === "medical"
        ? batchStates?.medicineData?.payload
        : batchStates?.nonmedicineData?.payload;

    // 🛡️ Wait until optionsList is available
    if (!Array.isArray(optionsList) || optionsList.length === 0) return;

    const medBC = optionsList.find(
      (item) =>
        String(item?.id) === (String(medicineId) || String(selectedMedicineId))
    );

    if (medNonMedTrue) {
      if (medBC) {
        setMedCodeBoolen(true);
        setProductName(
          `${medBC?.name} ${medBC?.dose?.trim() ? `(${medBC?.dose})` : ""}`
        );
        setAllMedicalProductId(medBC?.id);
        setMedicinError("");
      } else {
        setMedCodeBoolen(false);
        setProductName("");
        setAllMedicalProductId("");
      }
    } else {
      if (medBC) {
        setMedCodeBoolen(true);
        setMedicineName(
          `${medBC?.name} ${medBC?.dose?.trim() ? `(${medBC?.dose})` : ""}`
        );
        setSelectedMed(medBC);
        setMedicinError("");
      } else {
        setMedCodeBoolen(false);
        setMedicineName("");
        setSelectedMed("");
      }
    }
  }, [
    medicineId,
    selectedMedicineId,
    batchStates?.medicalType,
    batchStates?.medicineData?.payload,
    batchStates?.nonmedicineData?.payload,
  ]);

  // const handleDiscountAmountChange = (index, value) => {
  //   const newSalesData = [...salesData];
  //   let discountAmount = parseFloat(value);
  //   // Prevent negative discount amount
  //   if (discountAmount < 0) {
  //     discountAmount = 0;
  //   }
  //   // Get the total amount to be paid
  //   const totalAmount = newSalesData[index]?.amount_to_be_paid || 0;
  //   // Ensure discount amount is not greater than the total amount
  //   if (discountAmount > totalAmount) {
  //     discountAmount = totalAmount; // Set discount amount to total amount if it exceeds
  //   }
  //   // Update discount amount for the selected medicine
  //   if (!isNaN(discountAmount)) {
  //     let discountPercentage = (discountAmount / totalAmount) * 100;

  //     // Round discount percentage to 2 decimal places
  //     discountPercentage = parseFloat(discountPercentage.toFixed(2));

  //     // Round discount amount to 2 decimal places
  //     discountAmount = parseFloat(discountAmount.toFixed(2));

  //     // Update discount percentage and final payable amount
  //     newSalesData[index].sale_discount_percentage = discountPercentage;
  //     newSalesData[index].sale_discount_amount = discountAmount;
  //     newSalesData[index].amount_after_discount = totalAmount - discountAmount;
  //   } else {
  //     // Reset discount values for invalid input
  //     newSalesData[index].sale_discount_percentage = 0;
  //     newSalesData[index].sale_discount_amount = 0;
  //     newSalesData[index].amount_after_discount =
  //       newSalesData[index].amount_to_be_paid || 0;
  //   }

  //   // Ensure all other medicines have 0 discount if no discount is set
  //   newSalesData?.forEach((item, idx) => {
  //     if (
  //       idx !== index && // Skip the currently updated item
  //       (item?.sale_discount_percentage === undefined ||
  //         item?.sale_discount_percentage === null)
  //     ) {
  //       const totalAmount = item?.amount_to_be_paid || 0;
  //       item.sale_discount_percentage = 0;
  //       item.sale_discount_amount = 0;
  //       item.amount_after_discount = totalAmount;
  //     }
  //   });

  //   // Update state and localStorage
  //   setSalesData(newSalesData);
  //   localStorage?.setItem("salesData", JSON?.stringify(newSalesData));
  // };

  // functions for validate batch number for cost and sell price
  const validateBatchNumber = async (medicineId) => {
    try {
      const res = await dispatch(
        validateBatch({
          pharmacy_id: pharmacyId,
          medicine_id: medicineId,
        })
      );

      const batch = res?.payload?.data;

      if (res?.payload?.success && batch) {
        // Auto-fill fields from the batch data
        setBatchStates((prev) => ({
          ...prev,
          batchName: batch?.batch_number || "",
          costPrice: batch?.cost_price || "",
          sellPrice: batch?.sell_price || "",
          supplier: batch?.supplier_name || "",
          supplierId: batch?.supplier_id || null,
          expirySelectedDate: batch?.expiry_date || null,
          selectedBatch: batch,
        }));
      } else {
        setBatchStates((prev) => ({
          ...prev,
          selectedBatch: null,
        }));
      }
    } catch (error) {
      console.error("Error validating batch data:", error);
    }
  };
  return (
    <>
      <Formik
        initialValues={addBatchInitialValues}
        //validationSchema={!isEdit ? addBatchValidationSchema : ""}
        // onSubmit={handleSubmit}
      >
        <Form>
          <Box sx={{ mt: 2 }}>
            {!isEdit && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: { xs: "column", sm: "row" },
                  gap: 2,
                  mb: 2,
                }}
              >
                <Typography variant="h6">Product Type:</Typography>

                <RadioGroup
                  row
                  aria-label="date-filter-type"
                  name="date-filter-type"
                  value={batchStates?.medicalType}
                  onChange={(e) => handelMedicalType(e?.target?.value)}
                >
                  <FormControlLabel
                    value="medical"
                    control={<Radio />}
                    label="Medical"
                  />
                  <FormControlLabel
                    value="non-medical"
                    control={<Radio />}
                    label="Non Medical"
                  />
                </RadioGroup>
              </Box>
            )}

            {batchStates?.medicalType === "medical" ? (
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <Typography variant="h6" gutterBottom>
                    Bar Code{" "}
                    <span style={{ fontSize: "12px", color: "gray" }}>
                      (Optional)
                    </span>
                  </Typography>
                  <Field
                    as={TextField}
                    fullWidth
                    variant="outlined"
                    placeholder="Enter barcode."
                    // disabled={isEdit}
                    value={medBarcode}
                    onChange={handleBarChange}
                    inputProps={{
                      style: {
                        padding: "10px 12px",
                      },
                    }}
                  />
                  {/* {!isEdit && errors?.batchNoError && ( */}
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography variant="h6" gutterBottom>
                    Supplier
                  </Typography>

                  <Autocomplete
                    value={batchStates?.supplier}
                    onChange={async (event, value) => {
                      if (value) {
                        const selectedsupplier =
                          batchStates?.supplierData?.payload?.supplier?.find(
                            (supplier) =>
                              supplier?.supplier_company_name === value
                          );

                        setBatchStates((prevState) => ({
                          ...prevState,
                          supplierId: selectedsupplier?.id,
                          supplier: selectedsupplier?.supplier_company_name,
                        }));
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          supplierError: "", // Clear the error message if valid
                        }));
                        // Call the API and log the response
                        if (selectedsupplier?.id && pharmacyId) {
                          try {
                            const response = await getSupplierMedicines(
                              pharmacyId,
                              selectedsupplier.id
                            );
                            if (response?.data?.medicines) {
                              setSupplierMedicines(response.data.medicines);
                              setFilteredBySupplier(true);
                            } else {
                              setSupplierMedicines([]);
                              setFilteredBySupplier(false);
                            }
                          } catch (error) {
                            setSupplierMedicines([]);
                            setFilteredBySupplier(false);
                            console.error(
                              "Failed to fetch supplier medicines:",
                              error
                            );
                          }
                        }
                      } else {
                        setFilteredBySupplier(false);
                        setSupplierMedicines([]);
                      }
                    }}
                    id="combo-box-demo"
                    options={
                      Array.isArray(
                        batchStates?.supplierData?.payload?.supplier
                      ) &&
                      batchStates?.supplierData?.payload?.supplier?.length > 0
                        ? batchStates?.supplierData?.payload?.supplier?.map(
                            (supplier) => supplier?.supplier_company_name
                          )
                        : ["Please Add Supplier First"]
                    }
                    getOptionDisabled={(option) =>
                      option === "Please Add Supplier First"
                    }
                    disableClearable
                    popupIcon={null} //  Hides the default dropdown arrow
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Supplier"
                        sx={{
                          "& .MuiInputBase-input": {
                            padding: "1px 5px !important", // Ensures padding is applied correctly
                          },
                        }}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              <InputAdornment position="end">
                                <Typography
                                  onClick={handleOpenSupplierModal}
                                  sx={{
                                    cursor: "pointer",
                                    color: "#0A8DD0",
                                    fontWeight: 400,
                                    fontSize: "14px",
                                    marginRight: -3,
                                  }}
                                >
                                  + Add as New
                                </Typography>
                              </InputAdornment>
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                    onKeyDown={handleKeyDown}
                  />

                  {!isEdit && errors?.supplierError && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "5px",
                      }}
                    >
                      {errors?.supplierError}
                    </div>
                  )}
                </Grid>
                {isEdit ? (
                  <Grid item xs={12} sm={4}>
                    <Typography variant="h6" gutterBottom>
                      Name
                    </Typography>

                    {/* <div style={{ position: "relative", zIndex: 10 }}>
                      <Dropdown
                        data={filtered_list_edit}
                        handleChange={(e) => {
                            handleChangeEdit(e)
                        }}
                        isOpen={!isEdit && batchStates?.isOpen}
                        setIsOpen={(open) => {
                          if (!isEdit) {
                            setBatchStates({ ...batchStates, isOpen: open });
                          }
                        }}
                        value={medicineName}
                        medicine_value={(data) => {
                          if (!isEdit) {
                            setBatchStates((prevState) => ({
                              ...prevState,
                              isOpen: false,
                            }));
                            setAllMedicineId(data?.id);
                          }
                        }}
                        is_formula_drop={false}
                        addNewMed={() => {
                          if (!isEdit) handleOpenModal();
                        }}
                        sx={{
                          backgroundColor: isEdit ? "#f0f0f0" : "white",
                          color: isEdit ? "#a0a0a0" : "black",
                          pointerEvents: isEdit ? "none" : "auto",
                          opacity: isEdit ? 0.6 : 1,
                          cursor: isEdit ? "not-allowed" : "pointer",
                        }}
                        inputProps={{
                          style: {
                            padding: "10px 12px",
                          },
                        }}
                      />
                    </div> */}

                    <div style={{ position: "relative", zIndex: 10 }}>
                      <Dropdown
                        data={
                          filteredBySupplier
                            ? filtered_list_edit_supplier
                            : filtered_list_edit
                        }
                        handleChange={handleChangeEdit}
                        isOpen={batchStates?.isOpen}
                        setIsOpen={(open) =>
                          setBatchStates({
                            ...batchStates,
                            isOpen: open, // Sync isOpen with medicineFormData
                          })
                        }
                        value={medicineName}
                        medicine_value={(data) => {
                          setSelectedMed(data);
                          setMedBarcode(data?.barcode ?? "");
                          setBatchStates((prevState) => ({
                            ...prevState,
                            isOpen: false,
                          }));
                        }}
                        is_formula_drop={false}
                        addNewMed={() => handleOpenModal()}
                        stickyFooter={
                          filteredBySupplier ? (
                            <Box
                              sx={{
                                backgroundColor: "white",
                                mt: 0,
                              }}
                            >
                              <a
                                href="#"
                                style={{
                                  fontWeight: 400,
                                  color: "#0055A9",
                                  fontSize: "12px",
                                  textAlign: "left",
                                  cursor: "pointer",

                                  textDecoration: "none",
                                  display: "block",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  setFilteredBySupplier(false);
                                  setSupplierMedicines([]);
                                }}
                              >
                                Show all medicines
                              </a>
                            </Box>
                          ) : null
                        }
                      />
                    </div>
                  </Grid>
                ) : (
                  // add batch grid
                  <Grid item xs={12} sm={4}>
                    <Typography variant="h6" gutterBottom>
                      Name
                    </Typography>

                    <div style={{ position: "relative", zIndex: 10 }}>
                      <Dropdown
                        data={
                          filteredBySupplier
                            ? filtered_list_supplier
                            : filtered_list
                        }
                        handleChange={handleChange}
                        isOpen={batchStates?.isOpen}
                        setIsOpen={(open) =>
                          setBatchStates({
                            ...batchStates,
                            isOpen: open,
                          })
                        }
                        value={med_value}
                        medicine_value={(data) => {
                          setSelectedMed(data);
                          if (!data) {
                            setBatchStates((prev) => ({
                              ...prev,
                              batchName: "",
                              costPrice: "",
                              sellPrice: "",
                              supplier: "",
                              supplierId: null,
                              expirySelectedDate: null,
                              selectedBatch: null,
                            }));
                            return;
                          }
                          setBatchStates((prevState) => ({
                            ...prevState,
                            isOpen: false,
                          }));
                          validateBatchNumber(data?.id);
                        }}
                        is_formula_drop={false}
                        addNewMed={() => handleOpenModal()}
                        renderOption={(props, option) => (
                          <li {...props}>
                            {option.name}{" "}
                            {option.dose ? `(${option.dose})` : ""}
                          </li>
                        )}
                        stickyFooter={
                          filteredBySupplier ? (
                            <Box
                              sx={{
                                backgroundColor: "white",
                                mt: 0,
                              }}
                            >
                              <a
                                href="#"
                                style={{
                                  fontWeight: 400,
                                  color: "#0055A9",
                                  fontSize: "12px",
                                  textAlign: "left",
                                  cursor: "pointer",

                                  textDecoration: "none",
                                  display: "block",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  setFilteredBySupplier(false);
                                  setSupplierMedicines([]);
                                }}
                              >
                                Show all medicines
                              </a>
                            </Box>
                          ) : null
                        }
                      />
                    </div>

                    {medicinError && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "14px",
                          marginTop: "5px",
                        }}
                      >
                        {medicinError}
                      </div>
                    )}
                  </Grid>
                )}
                <Grid item xs={12} sm={4}>
                  <Typography variant="h6" gutterBottom>
                    Batch No.
                  </Typography>
                  <Field
                    as={TextField}
                    fullWidth
                    variant="outlined"
                    name="batch_no"
                    placeholder="Enter batch no."
                    value={batchStates?.batchName}
                    onKeyDown={handleKeyDown}
                    onChange={handleInputChange}
                    inputProps={{
                      style: {
                        padding: "10px 12px",
                      },
                    }}
                  />
                  {/* {!isEdit && errors?.batchNoError && ( */}
                  {errors?.batchNoError && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "5px",
                        marginLeft: 2,
                      }}
                    >
                      {errors?.batchNoError}
                    </div>
                  )}
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Typography variant="h6" gutterBottom>
                    Total Boxes
                  </Typography>
                  <Field
                    as={TextField}
                    fullWidth
                    type="number"
                    variant="outlined"
                    name="boxQuantity"
                    placeholder="Add no. of boxes"
                    value={batchStates?.boxQuantity}
                    onChange={handleStockCalculationChange}
                    onKeyDown={handleKeyDownNonNegative}
                    inputProps={{
                      style: {
                        padding: "10px 12px",
                        min: 0,
                      },
                    }}
                  />

                  {errors?.boxQuantityError && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "5px",
                      }}
                    >
                      {errors?.boxQuantityError}
                    </div>
                  )}
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography variant="h6" gutterBottom>
                    Units per box
                  </Typography>
                  <Field
                    as={TextField}
                    type="number"
                    fullWidth
                    variant="outlined"
                    name="unitsPerBox"
                    placeholder="Add no. of units per box"
                    value={batchStates?.unitsPerBox}
                    onChange={handleStockCalculationChange}
                    onKeyDown={handleKeyDownNonNegative}
                    inputProps={{
                      style: {
                        padding: "10px 12px",
                        min: 0,
                      },
                    }}
                  />
                  {errors?.unitsPerBoxError && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "5px",
                      }}
                    >
                      {errors?.unitsPerBoxError}
                    </div>
                  )}

                  {errors?.quantityError && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "5px",
                      }}
                    >
                      {errors?.quantityError}
                    </div>
                  )}
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography variant="h6" gutterBottom>
                    Total Stock
                  </Typography>
                  <Field
                    as={TextField}
                    fullWidth
                    type="number"
                    variant="outlined"
                    name="quantity"
                    placeholder="Add Quantity"
                    disabled={
                      Number.isInteger(batchStates.unitsPerBox) &&
                      Number.isInteger(batchStates.boxQuantity) &&
                      batchStates.unitsPerBox > 0 &&
                      batchStates.boxQuantity > 0
                    }
                    value={batchStates?.quantity}
                    onChange={handleStockCalculationChange}
                    onKeyDown={handleKeyDownNonNegative}
                    inputProps={{
                      style: {
                        padding: "10px 12px",
                        min: 0,
                      },
                    }}
                  />
                  {/* <div
                style={{ color: "red", fontSize: "14px", marginTop: "5px" }}
              >
                <ErrorMessage name="quantity" component="div" />
              </div> */}
                  {/* {!isEdit && errors?.quantityError && ( */}
                  {errors?.quantityError && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "5px",
                      }}
                    >
                      {errors?.quantityError}
                    </div>
                  )}
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Typography variant="h6" gutterBottom>
                    Cost Price
                  </Typography>
                  <Box
                    sx={{
                      position: "relative",
                      display: "flex",
                      gap: 1.5,
                    }}
                  >
                    <Field
                      as={TextField}
                      fullWidth
                      type="number"
                      variant="outlined"
                      name="cost_price"
                      placeholder="Units price"
                      value={batchStates?.costPrice}
                      onChange={handleInputChange}
                      onKeyDown={handleKeyDownNonNegative}
                      onBlur={handleBlur}
                      inputProps={{
                        style: { padding: "10px 12px" },
                      }}
                      
                    />
                    {/* Boxes Price */}
                    <Field
                      as={TextField}
                      fullWidth
                      type="number"
                      variant="outlined"
                      name="cost_price_per_box"
                      placeholder="Boxes Price"
                      value={batchStates?.cost_price_per_box}
                      onChange={handleInputChange}
                      onKeyDown={handleKeyDownNonNegative}
                      inputProps={{ style: { padding: "10px 12px" } }}
                      onBlur={handleBlur}
                    />

                    {/* Half-in-half Icon */}
                    <Box
                      sx={{
                        position: "absolute",
                        top: "60%",
                        left: "49.5%",
                        transform: "translate(-50%, -50%)",
                        zIndex: 2,
                        backgroundColor: "#fff",
                        padding: "0 4px",
                      }}
                    >
                      <img
                        src={InputIcon}
                        alt="link icon"
                        style={{
                          width: "24px",
                          height: "24px",
                        }}
                      />
                    </Box>
                  </Box>

                  {/* {!isEdit && errors?.costPriceError ? ( */}
                  {errors?.costPriceError ? (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "5px",
                      }}
                    >
                      {errors?.costPriceError}
                    </div>
                  ) : (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "5px",
                      }}
                    >
                      {errors?.costPriceError}
                    </div>
                  )}
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Typography variant="h6" gutterBottom>
                    Sell Price
                  </Typography>

                  {/* Relative wrapper to handle icon overlay */}
                  <Box
                    sx={{
                      position: "relative",
                      display: "flex",
                      gap: 1.5,
                    }}
                  >
                    {/* Units Price */}
                    <Field
                      as={TextField}
                      fullWidth
                      type="number"
                      variant="outlined"
                      name="sell_price"
                      placeholder="Units Price"
                      value={batchStates?.sellPrice}
                      onChange={handleInputChange}
                      onKeyDown={handleKeyDownNonNegative}
                      inputProps={{ style: { padding: "10px 12px" } }}
                    />

                    {/* Boxes Price */}
                    <Field
                      as={TextField}
                      fullWidth
                      type="number"
                      variant="outlined"
                      name="boxesPrice"
                      placeholder="Boxes Price"
                      value={batchStates?.sell_price_per_box}
                      inputProps={{ style: { padding: "10px 12px" } }}
                      disabled
                    />

                    {/* Half-in-half Icon */}
                    <Box
                      sx={{
                        position: "absolute",
                        top: "60%",
                        left: "49.5%",
                        transform: "translate(-50%, -50%)",
                        zIndex: 2,
                        backgroundColor: "#fff",
                        padding: "0 4px",
                      }}
                    >
                      <img
                        src={InputIcon}
                        alt="link icon"
                        style={{
                          width: "24px",
                          height: "24px",
                        }}
                      />
                    </Box>
                  </Box>

                  {/* Errors if needed */}
                  {errors?.sellPriceError ? (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "5px",
                      }}
                    >
                      {errors?.sellPriceError}
                    </div>
                  ) : (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "5px",
                      }}
                    >
                      {errors?.sellPriceError}
                    </div>
                  )}
                </Grid>

                {/* <Grid item xs={12} sm={6}>
                  <Typography variant="h6" gutterBottom>
                    Supplier Invoice Attachment
                  </Typography>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      name="invoice_number"
                      placeholder={batchStates?.filePath || "Upload Supplier Invoice"}
                      value={batchStates?.filePath}
                      InputProps={{
                        readOnly: true,
                        endAdornment: (
                          <>
                            {batchStates?.filePath && (
                              <IconButton
                                onClick={handleRemoveFile}
                                size="small"
                              >
                                <CloseIcon />
                              </IconButton>
                            )}
                            <Button
                              onClick={handleButtonClick}
                              variant="text"
                              style={{
                                position: "absolute",
                                top: 8,
                                right: 16,
                                height: "75%",
                                borderRadius: 0,
                                background: "white",
                                color: "inherit",
                                border: "none",
                                padding: 0,
                                cursor: "pointer",
                                outline: "inherit",
                                fontSize: "14px",
                                fontWeight: 500,
                                textTransform:"none"
                              }}
                            >
                              + Upload New File
                            </Button>
                          </>
                        ),
                      }}
                    />
                    <input
                      type="file"
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />
                  </div>
                </Grid> */}

                <Grid item xs={12} sm={4}>
                  <Typography variant="h6" gutterBottom>
                    Expire Date
                  </Typography>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      views={["day", "month", "year"]}
                      open={batchStates?.openExpiryDatePicker}
                      onOpen={() =>
                        setBatchStates((prevState) => ({
                          ...prevState,
                          openExpiryDatePicker: true,
                        }))
                      }
                      onClose={() =>
                        setBatchStates((prevState) => ({
                          ...prevState,
                          openExpiryDatePicker: false,
                        }))
                      }
                      inputFormat="yyyy-MM-dd"
                      value={
                        isEdit
                          ? batchStates?.expDate
                          : batchStates?.expirySelectedDate
                      }
                      onChange={
                        isEdit
                          ? handleExpiryDateChange
                          : handleAddExpiryDateChange
                      }
                      minDate={
                        isEdit
                          ? batchStates?.prodDate
                          : batchStates?.productionSelectedDate
                      } // Set minDate to the production date
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="expiry_date"
                          inputProps={{
                            ...params.inputProps,
                            placeholder: "yyyy-mm-dd",
                            style: { padding: "10px 12px" },
                          }}
                          fullWidth
                          onKeyDown={handleKeyDown}
                          onClick={(e) =>
                            setBatchStates((prevState) => ({
                              ...prevState,
                              openExpiryDatePicker: true,
                            }))
                          }
                        />
                      )}
                    />
                  </LocalizationProvider>
                  {!isEdit && errors?.dateError && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "5px",
                      }}
                    >
                      {errors?.dateError}
                    </div>
                  )}
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Typography variant="h6" gutterBottom>
                    Shelf{" "}
                  </Typography>
                  <Autocomplete
                    value={batchStates?.selectedShelf || null}
                    onChange={(event, value) => {
                      setBatchStates((prev) => ({
                        ...prev,
                        selectedShelf: value,
                      }));
                      setErrors((prev) => ({
                        ...prev,
                        selectedShelfError: "",
                      }));
                    }}
                    id="shelf-select-dropdown"
                    options={shelfData}
                    getOptionLabel={(option) => option?.name || ""}
                    disableClearable
                    popupIcon={null}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        inputRef={inputRef}
                        placeholder="Select Shelf"
                        sx={{
                          "& .MuiInputBase-input": {
                            padding: "1px 5px !important",
                          },
                        }}
                        error={!!errors?.selectedShelfError}
                        helperText={errors?.selectedShelfError}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              <InputAdornment position="end">
                                <Typography
                                  onClick={() => {
                                    // 👇 Close dropdown before opening modal
                                    if (inputRef.current) {
                                      inputRef.current.blur();
                                    }
                                    handleOpenShelfModal(); // then open modal
                                  }}
                                  sx={{
                                    cursor: "pointer",
                                    color: "#0A8DD0",
                                    fontWeight: 400,
                                    fontSize: "14px",
                                    marginRight: -3,
                                  }}
                                >
                                  + Add as New
                                </Typography>
                              </InputAdornment>
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                    onKeyDown={handleKeyDown}
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Typography variant="h6" gutterBottom>
                    Production Date{" "}
                    <span style={{ fontSize: "12px", color: "gray" }}>
                      (Optional)
                    </span>
                  </Typography>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      views={["day", "month", "year"]}
                      open={batchStates?.openProductionDatePicker}
                      onOpen={() =>
                        setBatchStates((prevState) => ({
                          ...prevState,
                          openProductionDatePicker: true,
                        }))
                      }
                      onClose={() =>
                        setBatchStates((prevState) => ({
                          ...prevState,
                          openProductionDatePicker: false,
                        }))
                      }
                      inputFormat="yyyy-MM-dd"
                      value={
                        isEdit
                          ? batchStates?.prodDate
                          : batchStates?.productionSelectedDate
                      }
                      onChange={
                        isEdit
                          ? handleProductionDateChange
                          : handleAddProductionDateChange
                      }
                      maxDate={currentDate} // Disable dates after the current date
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="production_date"
                          inputProps={{
                            ...params.inputProps,
                            placeholder: "yyyy-mm-dd",
                            style: { padding: "10px 12px" },
                          }}
                          fullWidth
                          onKeyDown={handleKeyDown}
                          onClick={(e) =>
                            setBatchStates((prevState) => ({
                              ...prevState,
                              openProductionDatePicker: true,
                            }))
                          }
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
                {showMoreFields && (
                  <>
                    <Grid item xs={12} sm={4}>
                      <Typography variant="h6" gutterBottom>
                        Sales Tax{" "}
                        <span style={{ fontSize: "12px", color: "gray" }}>
                          (Optional)
                        </span>
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          gap: 1,
                        }}
                      >
                        <Field
                          as={TextField}
                          fullWidth
                          type="number"
                          variant="outlined"
                          name="tax_amount"
                          placeholder="Add sales tax"
                          value={batchStates?.tax_amount}
                          onChange={handleInputChange}
                          onKeyDown={handleKeyDown}
                          inputProps={{ style: { padding: "10px 12px" } }}
                        />
                      </Box>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <Typography variant="h6" gutterBottom>
                        Stock Purchase Price{" "}
                        <span style={{ fontSize: "12px", color: "gray" }}>
                          (Optional)
                        </span>
                      </Typography>
                      <Field
                        as={TextField}
                        fullWidth
                        type="number"
                        variant="outlined"
                        name="purchase_price"
                        placeholder="Add Price"
                        value={batchStates?.stock_purchase_cost}
                        onKeyDown={handleKeyDown}
                        onChange={handleInputChange}
                        inputProps={{
                          style: { padding: "10px 12px" },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography variant="h6" gutterBottom>
                        Extra Discount/Bonus{" "}
                        <span style={{ fontSize: "12px", color: "gray" }}>
                          (Optional)
                        </span>
                      </Typography>
                      <Field
                        as={TextField}
                        fullWidth
                        type="number"
                        variant="outlined"
                        name="batch_discount"
                        placeholder="Discount/Bonus"
                        value={batchStates?.extra_discount}
                        onKeyDown={handleKeyDown}
                        onChange={handleInputChange}
                        disabled={!batchStates?.stock_purchase_cost > 0}
                        inputProps={{
                          style: { padding: "10px 12px" },
                        }}
                      />
                      {errors?.extraDiscountBonusError && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "14px",
                            marginTop: "5px",
                            marginLeft: 2,
                          }}
                        >
                          {errors?.extraDiscountBonusError}
                        </div>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography variant="h6" gutterBottom>
                        Stock Purchase Date{" "}
                        <span style={{ fontSize: "12px", color: "gray" }}>
                          (Optional)
                        </span>
                      </Typography>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          views={["day", "month", "year"]}
                          open={batchStates?.openStockPicker}
                          onOpen={() =>
                            setBatchStates((prevState) => ({
                              ...prevState,
                              openStockPicker: true,
                            }))
                          }
                          onClose={() =>
                            setBatchStates((prevState) => ({
                              ...prevState,
                              openStockPicker: false,
                            }))
                          }
                          inputFormat="yyyy-MM-dd"
                          value={
                            isEdit
                              ? batchStates?.stockDate
                              : batchStates?.stockSelectDate || new Date()
                          }
                          onChange={
                            isEdit
                              ? handleStockDateChange
                              : handleAddStockSelectDateChange
                          }
                          maxDate={currentDate}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="batch_purchase_date"
                              inputProps={{
                                ...params.inputProps,
                                placeholder: "yyyy-mm-dd",
                                style: { padding: "10px 12px" },
                              }}
                              fullWidth
                              onKeyDown={handleKeyDown}
                              onClick={(e) =>
                                setBatchStates((prevState) => ({
                                  ...prevState,
                                  openStockPicker: true,
                                }))
                              }
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography variant="h6" gutterBottom>
                        Supplier Invoice No.{" "}
                        <span style={{ fontSize: "12px", color: "gray" }}>
                          (Optional)
                        </span>
                      </Typography>
                      <Field
                        as={TextField}
                        fullWidth
                        variant="outlined"
                        name="invoice_number"
                        placeholder="Enter Invoice no. of Supplier"
                        value={batchStates?.invoiceNumber}
                        onChange={handleInputChange}
                        onKeyDown={handleKeyDown}
                        inputProps={{ style: { padding: "10px 12px" } }}
                      />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <Typography variant="h6" gutterBottom>
                        Expiry Reminder{" "}
                        <span style={{ fontSize: "12px", color: "gray" }}>
                          (Optional)
                        </span>
                      </Typography>

                      <Autocomplete
                        value={batchStates?.expiryReminder}
                        onChange={(event, value) => {
                          setBatchStates((prevState) => ({
                            ...prevState,
                            expiryReminder: value,
                          }));
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            expiryReminderError: "", // Clear the error message if valid
                          }));
                        }}
                        id="expiry-reminder-dropdown"
                        options={Array.from({ length: 12 }, (_, i) =>
                          i === 0 ? "1 Month Before" : `${i + 1} Months Before`
                        )}
                        disableClearable
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Set Expiry Reminder"
                            sx={{
                              "& .MuiInputBase-input": {
                                padding: "1px 5px !important", // Ensures padding is applied correctly
                              },
                            }}
                          />
                        )}
                        onKeyDown={handleKeyDown}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography variant="h6" gutterBottom>
                        Stock Out Reminder{" "}
                        <span style={{ fontSize: "12px", color: "gray" }}>
                          (Optional)
                        </span>
                      </Typography>

                      <Autocomplete
                        value={batchStates?.stockOutReminder}
                        onChange={(event, value) => {
                          setBatchStates((prevState) => ({
                            ...prevState,
                            stockOutReminder: value,
                          }));
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            stockOutReminderError: "", // Clear the error message if valid
                          }));
                        }}
                        id="stock-out-reminder-dropdown"
                        options={Array.from(
                          { length: 9 },
                          (_, i) => `${(i + 1) * 10}%`
                        )}
                        disableClearable
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Set Stock Out Reminder"
                            sx={{
                              "& .MuiInputBase-input": {
                                padding: "1px 5px !important", // Ensures padding is applied correctly
                              },
                            }}
                          />
                        )}
                        onKeyDown={handleKeyDown}
                      />
                    </Grid>
                  </>
                )}
              </Grid>
            ) : (
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <Typography variant="h6" gutterBottom>
                    Bar Code{" "}
                    <span style={{ fontSize: "12px", color: "gray" }}>
                      (Optional)
                    </span>
                  </Typography>
                  <Field
                    as={TextField}
                    fullWidth
                    variant="outlined"
                    placeholder="Enter barcode."
                    // disabled={isEdit}
                    value={medBarcode}
                    onChange={handleBarChange}
                    inputProps={{
                      style: { padding: "10px 12px" },
                    }}
                  />
                  {/* {!isEdit && errors?.batchNoError && ( */}
                </Grid>
                {isEdit ? (
                  <Grid item xs={12} sm={4}>
                    <Typography variant="h6" gutterBottom>
                      Name
                    </Typography>
                    <div style={{ position: "relative", zIndex: 10 }}>
                      <ProductDropDown
                        data={
                          filteredBySupplier
                            ? filtered_listProduct_edit_supplier
                            : filtered_listProduct_edit
                        }
                        handleChange={handleChangeProductEdit}
                        isOpen={batchStates?.isOpen}
                        setIsOpen={(open) => {
                          setBatchStates({
                            ...batchStates,
                            isOpen: open, // Sync isOpen with medicineFormData
                          });
                        }}
                        value={ProductName}
                        medicine_value={(data) => {
                          setAllMedicalProductId(data?.id);
                          setMedBarcode(data?.barcode ?? "");
                          setBatchStates((prevState) => ({
                            ...prevState,
                            isOpen: false,
                          }));
                        }}
                        product_name={false}
                        addNewMed={() => {
                          handleOpenProductModal();
                          setMedNonMedTrue(true);
                        }}
                      />
                    </div>
                  </Grid>
                ) : (
                  // add batch grid
                  <Grid item xs={12} sm={4}>
                    <Typography variant="h6" gutterBottom>
                      Name
                    </Typography>
                    <div style={{ position: "relative", zIndex: 10 }}>
                      <ProductDropDown
                        data={
                          filteredBySupplier
                            ? filtered_list_product_supplier
                            : filtered_list_product
                        }
                        handleChange={handleChange}
                        isOpen={batchStates?.isOpen}
                        setIsOpen={(open) =>
                          setBatchStates({
                            ...batchStates,
                            isOpen: open, // Sync isOpen with medicineFormData
                          })
                        }
                        value={med_value}
                        medicine_value={(data) => {
                          setSelectedMed(data);
                          setBatchStates((prevState) => ({
                            ...prevState,
                            isOpen: false,
                          }));
                          // Auto-validate and set fields
                          validateBatchNumber(data?.id);
                        }}
                        product_name={false}
                        addNewMed={() => handleOpenProductModal()}
                        stickyFooter={
                          filteredBySupplier ? (
                            <a
                              href="#"
                              style={{
                                fontWeight: 400,
                                color: "#0055A9",
                                fontSize: "12px",
                                textAlign: "left",
                                cursor: "pointer",
                                textDecoration: "none",
                                display: "block",
                              }}
                              onClick={(e) => {
                                e.preventDefault();
                                setFilteredBySupplier(false);
                                setSupplierMedicines([]);
                              }}
                            >
                              Show all medicines
                            </a>
                          ) : null
                        }
                      />
                    </div>

                    {medicinError && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "14px",
                          marginTop: "5px",
                        }}
                      >
                        {medicinError}
                      </div>
                    )}
                  </Grid>
                )}
                <Grid item xs={12} sm={4}>
                  <Typography variant="h6" gutterBottom>
                    Batch No.
                  </Typography>
                  <Field
                    as={TextField}
                    fullWidth
                    variant="outlined"
                    name="batch_no"
                    placeholder="Enter batch no."
                    value={batchStates?.batchName}
                    onKeyDown={handleKeyDown}
                    onChange={handleInputChange}
                    inputProps={{ style: { padding: "10px 12px" } }} // Call function to clear error message on batch number change
                  />
                  {!isEdit && errors?.batchNoError && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "5px",
                        marginLeft: 2,
                      }}
                    >
                      {errors?.batchNoError}
                    </div>
                  )}
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography variant="h6" gutterBottom>
                    Total Boxes
                  </Typography>
                  <Field
                    as={TextField}
                    fullWidth
                    type="number"
                    variant="outlined"
                    name="boxQuantity"
                    placeholder="Add no. of boxes"
                    value={batchStates?.boxQuantity}
                    onChange={handleStockCalculationChange}
                    onKeyDown={handleKeyDownNonNegative}
                    inputProps={{
                      style: {
                        padding: "10px 12px",
                        min: 0,
                      },
                    }}
                  />

                  {errors?.boxQuantityError && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "5px",
                      }}
                    >
                      {errors?.boxQuantityError}
                    </div>
                  )}
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography variant="h6" gutterBottom>
                    Units per box
                  </Typography>
                  <Field
                    as={TextField}
                    type="number"
                    fullWidth
                    variant="outlined"
                    name="unitsPerBox"
                    placeholder="Add no. of units per box"
                    value={batchStates?.unitsPerBox}
                    onChange={handleStockCalculationChange}
                    onKeyDown={handleKeyDownNonNegative}
                    inputProps={{
                      style: {
                        padding: "10px 12px",
                        min: 0,
                      },
                    }}
                  />

                  {errors?.unitsPerBoxError && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "5px",
                      }}
                    >
                      {errors?.unitsPerBoxError}
                    </div>
                  )}
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography variant="h6" gutterBottom>
                    Total Stock
                  </Typography>
                  <Field
                    as={TextField}
                    fullWidth
                    type="number"
                    variant="outlined"
                    disabled={
                      Number.isInteger(batchStates.unitsPerBox) &&
                      Number.isInteger(batchStates.boxQuantity) &&
                      batchStates.unitsPerBox > 0 &&
                      batchStates.boxQuantity > 0
                    }
                    name="quantity"
                    placeholder="Add Quantity"
                    value={batchStates?.quantity}
                    onChange={handleStockCalculationChange}
                    onKeyDown={handleKeyDownNonNegative}
                    inputProps={{
                      style: {
                        padding: "10px 12px",
                        min: 0,
                      },
                    }}
                  />

                  {errors?.quantityError && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "5px",
                      }}
                    >
                      {errors?.quantityError}
                    </div>
                  )}
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Typography variant="h6" gutterBottom>
                    Cost Price
                  </Typography>
                  {/* <Field
                    as={TextField}
                    fullWidth
                    variant="outlined"
                    name="cost_price"
                    placeholder="Add cost price"
                    value={batchStates?.costPrice}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDownNonNegative}
                    inputProps={{ style: { padding: "10px 12px" } }}
                  /> */}
                  <Box
                    sx={{
                      position: "relative",
                      display: "flex",
                      gap: 1.5,
                    }}
                  >
                    <Field
                      as={TextField}
                      fullWidth
                      type="number"
                      variant="outlined"
                      name="cost_price"
                      placeholder="Units price"
                      value={batchStates?.costPrice}
                      onChange={handleInputChange}
                      onKeyDown={handleKeyDownNonNegative}
                      inputProps={{
                        style: { padding: "10px 12px" },
                      }}
                      disabled
                    />
                    {/* Boxes Price */}
                    <Field
                      as={TextField}
                      fullWidth
                      type="number"
                      variant="outlined"
                      name="cost_price_per_box"
                      placeholder="Boxes Price"
                      value={batchStates?.cost_price_per_box}
                      onChange={handleInputChange}
                      onKeyDown={handleKeyDownNonNegative}
                      inputProps={{ style: { padding: "10px 12px" } }}
                      onBlur={handleBlur}
                    />

                    {/* Half-in-half Icon */}
                    <Box
                      sx={{
                        position: "absolute",
                        top: "60%",
                        left: "49.5%",
                        transform: "translate(-50%, -50%)",
                        zIndex: 2,
                        backgroundColor: "#fff",
                        padding: "0 4px",
                      }}
                    >
                      <img
                        src={InputIcon}
                        alt="link icon"
                        style={{
                          width: "24px",
                          height: "24px",
                        }}
                      />
                    </Box>
                  </Box>
                  {errors?.costPriceError ? (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "5px",
                      }}
                    >
                      {errors?.costPriceError}
                    </div>
                  ) : (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "5px",
                      }}
                    >
                      {errors?.costPriceLessError}
                    </div>
                  )}
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Typography variant="h6" gutterBottom>
                    Sell Price
                  </Typography>
                  {/* <Field
                    as={TextField}
                    fullWidth
                    variant="outlined"
                    name="sell_price"
                    placeholder="Add sell price"
                    value={batchStates?.sellPrice}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDownNonNegative}
                    inputProps={{ style: { padding: "10px 12px" } }}
                  /> */}
                  <Box
                    sx={{
                      position: "relative",
                      display: "flex",
                      gap: 1.5,
                    }}
                  >
                    {/* Units Price */}
                    <Field
                      as={TextField}
                      fullWidth
                      type="number"
                      variant="outlined"
                      name="sell_price"
                      placeholder="Units Price"
                      value={batchStates?.sellPrice}
                      onChange={handleInputChange}
                      onKeyDown={handleKeyDownNonNegative}
                      inputProps={{ style: { padding: "10px 12px" } }}
                    />

                    {/* Boxes Price */}
                    <Field
                      as={TextField}
                      fullWidth
                      type="number"
                      variant="outlined"
                      name="boxesPrice"
                      placeholder="Boxes Price"
                      value={batchStates?.sell_price_per_box}
                      inputProps={{ style: { padding: "10px 12px" } }}
                      disabled
                    />

                    {/* Half-in-half Icon */}
                    <Box
                      sx={{
                        position: "absolute",
                        top: "60%",
                        left: "49.5%",
                        transform: "translate(-50%, -50%)",
                        zIndex: 2,
                        backgroundColor: "#fff",
                        padding: "0 4px",
                      }}
                    >
                      <img
                        src={InputIcon}
                        alt="link icon"
                        style={{
                          width: "24px",
                          height: "24px",
                        }}
                      />
                    </Box>
                  </Box>
                  {!isEdit && errors?.sellPriceError && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "5px",
                      }}
                    >
                      {errors?.sellPriceError}
                    </div>
                  )}
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Typography variant="h6" gutterBottom>
                    Expire Date
                  </Typography>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      views={["day", "month", "year"]}
                      open={batchStates?.openExpiryDatePicker}
                      onOpen={() =>
                        setBatchStates((prevState) => ({
                          ...prevState,
                          openExpiryDatePicker: true,
                        }))
                      }
                      onClose={() =>
                        setBatchStates((prevState) => ({
                          ...prevState,
                          openExpiryDatePicker: false,
                        }))
                      }
                      inputFormat="yyyy-MM-dd"
                      value={
                        isEdit
                          ? batchStates?.expDate || null
                          : batchStates?.expirySelectedDate || null
                      } // Ensure null when no date is selected
                      onChange={
                        isEdit
                          ? handleExpiryDateChange
                          : handleAddExpiryDateChange
                      }
                      minDate={
                        isEdit
                          ? batchStates?.prodDate || null
                          : batchStates?.productionSelectedDate || null
                      } // Set minDate only when available
                      disableFuture={false} // Allow selection of future dates
                      shouldDisableYear={() => false} // Prevent auto-selecting year
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="expiry_date"
                          inputProps={{
                            ...params.inputProps,
                            placeholder: "yyyy-mm-dd",
                            style: { padding: "10px 12px" },
                          }}
                          fullWidth
                          onKeyDown={handleKeyDown}
                          onClick={() =>
                            setBatchStates((prevState) => ({
                              ...prevState,
                              openExpiryDatePicker: true,
                            }))
                          }
                        />
                      )}
                    />
                  </LocalizationProvider>

                  {!isEdit && errors?.dateError && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "5px",
                      }}
                    >
                      {errors?.dateError}
                    </div>
                  )}
                </Grid>

                {showMoreFields && (
                  <>
                    <Grid item xs={12} sm={4}>
                      <Typography variant="h6" gutterBottom>
                        Add Shelf{" "}
                      </Typography>

                      <Autocomplete
                        value={batchStates?.selectedShelf || null}
                        onChange={(event, value) => {
                          setBatchStates((prev) => ({
                            ...prev,
                            selectedShelf: value,
                          }));
                          setErrors((prev) => ({
                            ...prev,
                            selectedShelfError: "",
                          }));
                        }}
                        id="shelf-select-dropdown"
                        options={shelfData}
                        getOptionLabel={(option) => option?.name || ""}
                        disableClearable
                        popupIcon={null}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            inputRef={inputRef}
                            placeholder="Select Shelf"
                            sx={{
                              "& .MuiInputBase-input": {
                                padding: "1px 5px !important",
                              },
                            }}
                            error={!!errors?.selectedShelfError}
                            helperText={errors?.selectedShelfError}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  <InputAdornment position="end">
                                    <Typography
                                      onClick={() => {
                                        // 👇 Close dropdown before opening modal
                                        if (inputRef.current) {
                                          inputRef.current.blur();
                                        }
                                        handleOpenShelfModal(); // then open modal
                                      }}
                                      sx={{
                                        cursor: "pointer",
                                        color: "#0A8DD0",
                                        fontWeight: 400,
                                        fontSize: "14px",
                                        marginRight: -3,
                                      }}
                                    >
                                      + Add as New
                                    </Typography>
                                  </InputAdornment>
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                        onKeyDown={handleKeyDown}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography variant="h6" gutterBottom>
                        Sales Tax{" "}
                        <span style={{ fontSize: "12px", color: "gray" }}>
                          (Optional)
                        </span>
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          gap: 1,
                        }}
                      >
                        <Field
                          as={TextField}
                          fullWidth
                          type="number"
                          variant="outlined"
                          name="tax_amount"
                          placeholder="Add sales tax"
                          value={batchStates?.tax_amount}
                          onChange={handleInputChange}
                          onKeyDown={handleKeyDown}
                          inputProps={{ style: { padding: "10px 12px" } }}
                        />
                      </Box>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <Typography variant="h6" gutterBottom>
                        Stock Purchase Price{" "}
                        <span style={{ fontSize: "12px", color: "gray" }}>
                          (Optional)
                        </span>
                      </Typography>
                      <Field
                        as={TextField}
                        fullWidth
                        variant="outlined"
                        name="purchase_price"
                        placeholder="Add Price"
                        value={batchStates?.stock_purchase_cost}
                        onKeyDown={handleKeyDown}
                        onChange={handleInputChange} // Call function to clear error message on batch number change
                        inputProps={{ style: { padding: "10px 12px" } }}
                      />
                      {/* {!isEdit && errors?.batchNoError && ( */}
                      {errors?.batchPurchaseError && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "14px",
                            marginTop: "5px",
                            marginLeft: 2,
                          }}
                        >
                          {errors?.batchPurchaseError}
                        </div>
                      )}
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <Typography variant="h6" gutterBottom>
                        Extra Discount/Bonus{" "}
                        <span style={{ fontSize: "12px", color: "gray" }}>
                          (Optional)
                        </span>
                      </Typography>
                      <Field
                        as={TextField}
                        fullWidth
                        variant="outlined"
                        name="batch_discount"
                        placeholder="Discount/Bonus"
                        value={batchStates?.batch_discount}
                        onKeyDown={handleKeyDown}
                        onChange={handleInputChange}
                        disabled={!batchStates?.stock_purchase_cost > 0}
                        inputProps={{ style: { padding: "10px 12px" } }}
                      />
                      {errors?.extraDiscountBonusError && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "14px",
                            marginTop: "5px",
                            marginLeft: 2,
                          }}
                        >
                          {errors?.extraDiscountBonusError}
                        </div>
                      )}
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <Typography variant="h6" gutterBottom>
                        Stock Purchase Date{" "}
                        <span style={{ fontSize: "12px", color: "gray" }}>
                          (Optional)
                        </span>
                      </Typography>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          views={["day", "month", "year"]}
                          open={batchStates?.openStockPicker}
                          onOpen={() =>
                            setBatchStates((prevState) => ({
                              ...prevState,
                              openStockPicker: true,
                            }))
                          }
                          onClose={() =>
                            setBatchStates((prevState) => ({
                              ...prevState,
                              openStockPicker: false,
                            }))
                          }
                          inputFormat="yyyy-MM-dd"
                          value={
                            isEdit
                              ? batchStates?.stockDate
                              : batchStates?.stockSelectDate || new Date()
                          }
                          onChange={
                            isEdit
                              ? handleStockDateChange
                              : handleAddStockSelectDateChange
                          }
                          maxDate={currentDate}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="batch_purchase_date"
                              inputProps={{
                                ...params.inputProps,
                                placeholder: "yyyy-mm-dd",
                                style: { padding: "10px 12px" },
                              }}
                              fullWidth
                              onKeyDown={handleKeyDown}
                              onClick={(e) =>
                                setBatchStates((prevState) => ({
                                  ...prevState,
                                  openStockPicker: true,
                                }))
                              }
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <Typography variant="h6" gutterBottom>
                        Production Date{" "}
                        <span style={{ fontSize: "12px", color: "gray" }}>
                          (Optional)
                        </span>
                      </Typography>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          views={["day", "month", "year"]}
                          open={batchStates?.openProductionDatePicker}
                          onOpen={() =>
                            setBatchStates((prevState) => ({
                              ...prevState,
                              openProductionDatePicker: true,
                            }))
                          }
                          onClose={() =>
                            setBatchStates((prevState) => ({
                              ...prevState,
                              openProductionDatePicker: false,
                            }))
                          }
                          inputFormat="yyyy-MM-dd"
                          value={
                            isEdit
                              ? batchStates?.prodDate
                              : batchStates?.productionSelectedDate
                          }
                          onChange={
                            isEdit
                              ? handleProductionDateChange
                              : handleAddProductionDateChange
                          }
                          maxDate={currentDate} // Disable dates after the current date
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="production_date"
                              inputProps={{
                                ...params.inputProps,
                                placeholder: "yyyy-mm-dd",
                                style: { padding: "10px 12px" },
                              }}
                              fullWidth
                              onKeyDown={handleKeyDown}
                              onClick={(e) =>
                                setBatchStates((prevState) => ({
                                  ...prevState,
                                  openProductionDatePicker: true,
                                }))
                              }
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <Typography variant="h6" gutterBottom>
                        Expiry Reminder{" "}
                        <span style={{ fontSize: "12px", color: "gray" }}>
                          (Optional)
                        </span>
                      </Typography>

                      <Autocomplete
                        value={batchStates?.expiryReminder}
                        onChange={(event, value) => {
                          setBatchStates((prevState) => ({
                            ...prevState,
                            expiryReminder: value,
                          }));
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            expiryReminderError: "", // Clear the error message if valid
                          }));
                        }}
                        id="expiry-reminder-dropdown"
                        options={Array.from({ length: 12 }, (_, i) =>
                          i === 0 ? "1 Month Before" : `${i + 1} Months Before`
                        )}
                        disableClearable
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Set Expiry Reminder"
                            sx={{
                              "& .MuiInputBase-input": {
                                padding: "1px 5px !important", // Ensures padding is applied correctly
                              },
                            }}
                          />
                        )}
                        onKeyDown={handleKeyDown}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography variant="h6" gutterBottom>
                        Stock Out Reminder{" "}
                        <span style={{ fontSize: "12px", color: "gray" }}>
                          (Optional)
                        </span>
                      </Typography>

                      <Autocomplete
                        value={batchStates?.stockOutReminder}
                        onChange={(event, value) => {
                          setBatchStates((prevState) => ({
                            ...prevState,
                            stockOutReminder: value,
                          }));
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            stockOutReminderError: "", // Clear the error message if valid
                          }));
                        }}
                        id="stock-out-reminder-dropdown"
                        options={Array.from(
                          { length: 9 },
                          (_, i) => `${(i + 1) * 10}%`
                        )}
                        disableClearable
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Set Stock Out Reminder"
                            sx={{
                              "& .MuiInputBase-input": {
                                padding: "1px 5px !important", // Ensures padding is applied correctly
                              },
                            }}
                          />
                        )}
                        onKeyDown={handleKeyDown}
                      />
                    </Grid>
                  </>
                )}
              </Grid>
            )}
          </Box>

          <Box sx={{ width: "100%", mt: 3 }}>
            {errors?.apiError && <AppErrorMessage message={errors?.apiError} />}
          </Box>

          <Box sx={{ mt: 3, display: "flex", justifyContent: "space-between" }}>
            <Box>
              <Box
                onClick={() => setShowMoreFields((prev) => !prev)}
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 1,
                  borderRadius: "6px",
                  px: 1.5,
                  py: 0.5,
                  cursor: "pointer",
                  color: "#333",
                  fontWeight: 500,
                  fontSize: "14px",
                  transition: "background 0.3s",
                  "&:hover": {
                    bgcolor: "#d5d5d5",
                  },
                }}
              >
                {/* i icon in a rounded box */}
                <Box
                  sx={{
                    bgcolor: "#7f8fa6",
                    color: "white",
                    fontSize: "14px",
                    width: 18,
                    height: 18,
                    borderRadius: "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                  }}
                >
                  i
                </Box>

                {/* Show More or See Less Text */}
                <Typography
                  variant="body2"
                  sx={{ fontSize: "14px", fontWeight: 500 }}
                >
                  {showMoreFields ? "Show Less" : "Show More"}
                </Typography>

                {/* Arrow › or ˅ */}
                <Typography variant="body2">
                  {showMoreFields ? "›" : "›"}
                </Typography>
              </Box>
            </Box>

            <Box>
              <AppButton
                variant="contained"
                color="primary"
                type="button"
                onClick={handleSubmit}
                title={
                  batchStates?.loading ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : isEdit ? (
                    "Update"
                  ) : (
                    "Add"
                  )
                }
                sx={{ float: "right" }}
                disabled={batchStates?.loading} // Disable button when loading
              />
            </Box>
          </Box>
        </Form>
      </Formik>

      <AppModal
        title="Add Medical Product"
        open={batchStates?.openModal}
        handleClose={handleCloseModal}
        fullScreen={false}
        maxWidth="lg"
      >
        <AddMedicineModal
          handleClose={handleCloseModal}
          setOpenSnackbar={() => setOpenSnackbar()}
          getMedicine={fetchAllMedicine}
          setMedicineId={setMedicineId}
        />
      </AppModal>

      <AppModal
        title="Add New Product"
        open={batchStates?.openProductModal}
        handleClose={handleCloseProductModal}
        fullScreen={false}
        maxWidth="md"
      >
        <AddNonMedicalModal
          handleClose={handleCloseProductModal}
          setOpenSnackbar={() => setOpenSnackbar()}
          getMedical={getMedical}
          setMedicineId={setMedicineId}
          getMedicine={fetchAllMedicine}
        />
      </AppModal>

      <AppModal
        title="Add New Supplier"
        open={batchStates?.openSupplierModal}
        handleClose={handleCloseSupplierModal}
        fullScreen={false}
        maxWidth="md"
      >
        <AddSupplierModal
          handleClose={handleCloseSupplierModal}
          setOpenSnackbar={() => setOpenSnackbar(true)}
          getSupplier={fetchSupplierData}
          setAddSupplierId={setAddSupplierId}
        />
      </AppModal>

      <AppModal
        title="Supplier Batch Management"
        open={batchStates?.openSupplierBatchModal}
        handleClose={handleCloseSupplierBatchModal}
        fullScreen={false}
        maxWidth="lg"
      >
        <SupplierBatchModal
          allSupplier={allSupplier}
          shelfData={shelfData}
          supplierId={batchStates?.supplierId}
        />
      </AppModal>

      {batchStates?.openShelfModal && (
        <AddNewShelfModal
          handleClose={handleCloseShelfModal}
          isEdit={false}
          setReloadShelf={fetchShelves}
          setAddShelfId={setAddShelfId}
        />
      )}

      <BarcodeReader
        key={batchStates?.medicalType}
        onError={handleError}
        onScan={handleScan}
      />
    </>
  );
};
export default AddBatchModal;
